import type { AnimationItem } from 'lottie-web';

// TODO: move animation related assets and config to a shared location
import {
  ANIMATION_SEGMENT_UPLOADING,
  ANIMATION_SEGMENT_PARSING,
  ANIMATION_SEGMENT_SUCCESS,
} from '../../../Resume/EditResume/FileUpload/utils';

export enum AnimationTimings {
  UPLOADING = 1700,
  SUCCESS_DISPLAY = 2000,
}

export enum AnimationState {
  UPLOADING = 'UPLOADING',
  PROCESSING = 'PROCESSING',
  SUCCESS = 'SUCCESS',
}

export enum UploadState {
  UPLOADING = 'UPLOADING',
  GETTING_READY = 'GETTING_READY',
  FINISHING_UP = 'FINISHING_UP',
  STILL_WORKING = 'STILL_WORKING',
  SUCCESS = 'SUCCESS',
}

// Text messages to cycle through during upload/polling (all 4 messages)
export const UploadProgressStates = [
  UploadState.UPLOADING,
  UploadState.GETTING_READY,
  UploadState.FINISHING_UP,
  UploadState.STILL_WORKING,
] as const;

export const playAnimation = ({
  animationInstance,
  animationState,
}: {
  animationInstance: { current: AnimationItem | null };
  animationState?: AnimationState;
}) => {
  if (animationState && animationInstance.current) {
    const instance = animationInstance.current;

    if (animationState === AnimationState.UPLOADING) {
      instance.playSegments(ANIMATION_SEGMENT_UPLOADING, true);
    }
    if (animationState === AnimationState.PROCESSING) {
      instance.playSegments(ANIMATION_SEGMENT_PARSING, true);
    }
    if (animationState === AnimationState.SUCCESS) {
      instance.playSegments(ANIMATION_SEGMENT_SUCCESS, true);
    }
  }
};
